import Http from './../http';

const prefix = '/template';

export const getAll = (param) => {
  return Http.authApi().get(`${prefix}?tag_template=${param}`);
};

export const getByFlag = (flag_name) => {
  return Http.authApi().get(`${prefix}/flagTemplates/${flag_name}`);
};

export const getExclusive = (aid) => {
  return Http.authApi().get(`${prefix}/exclusiveTemplates/${aid}`);
};


export const updateType = (params) => {
  return Http.authApi().post(`${prefix}/updateType`, params);
};



// WEBPACK FOOTER //
// ./src/js/services/editor/template.js